function isRecord(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

/**
 * Cached sessions missing positive server clearance are treated as incomplete.
 * Protected surfaces remain frozen until `/me` or refresh validates the
 * server-side contact/device relationship.
 */
export function sessionNeedsServerContactClearance(session) {
  return isRecord(session) && session.contactVerificationDeviceCleared !== true;
}
